<template>
  <div class="recruit_content">
    <div class="recruit_left">
      <div class="recruit_search">
        <div class="search_div">
          <input
            class="search_input"
            placeholder="搜索 公司/职位（Search Company / Jobs）"
            v-model="Key"
            @keyup.enter="searchJobs()"
          />
          <div class="search_btn" @click="searchJobs()">
            <img
              src="@/assets/images/search_btn.png"
              class="search_btn__img"
              alt
            />
          </div>
        </div>
      </div>

      <div class="recruit_temp" v-if="tempList.length > 0">
        <div class="temp_head">
          <div class="temp_label">外包任务</div>
          <div class="temp_more" @click="tempMore()">更多</div>
        </div>
        <!--PC-->
        <ul class="temp_body">
          <li
            v-for="(item, index) in tempListToShow"
            :key="index"
            class="temp_li"
            @click="tempDetail(item)"
          >
            <div class="temp_title_salary">
              <div class="temp_title">{{ item.Title }}</div>
              <div class="temp_salary">{{ item.Salary }}</div>
            </div>
            <div class="temp_titleDesc">{{ item.Description }}</div>
            <div class="temp_status_timeDesc">
              <div :class="filterColor[item.Status]">
                {{ item.Status | filterStatus }}
              </div>
              <div class="temp_timeDesc">{{ item.TimeDesc }} 发布</div>
            </div>
          </li>
        </ul>
        <!--Mobile-->
        <el-carousel
          :interval="0"
          height="160px"
          arrow="always"
          class="temp_body_m"
        >
          <el-carousel-item
            v-for="(item, index) in tempList"
            :key="index"
            class="temp_li"
            @click.native="tempDetail(item)"
          >
            <div class="temp_title_salary">
              <div class="temp_title">{{ item.Title }}</div>
              <div class="temp_salary">{{ item.Salary }}</div>
            </div>
            <div class="temp_titleDesc">{{ item.Description }}</div>
            <div class="temp_status_timeDesc">
              <div :class="filterColor[item.Status]">
                {{ item.Status | filterStatus }}
              </div>
              <div class="temp_timeDesc">{{ item.TimeDesc }} 发布</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="recruit_filter">
        <div class="recruit_filter_left">
          <div class="rf_div">
            <div class="rf_label">职位类型</div>
            <ul class="rf_ul">
              <li
                @click="(type = index), searchJobs()"
                v-for="(job, index) in filterJobList"
                :key="index"
                class="rf_li"
                :class="{ active: type === index }"
              >
                {{ job }}
              </li>
            </ul>
          </div>

          <div style="margin: 10px 0 10px 0" class="rf_div">
            <div class="rf_label">时间范围</div>
            <ul class="rf_ul">
              <li
                @click="(Days = time.value), searchJobs()"
                v-for="(time, index) in filterTimeList"
                :key="index"
                class="rf_li"
                :class="{ active: Days === time.value }"
              >
                {{ time.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="recruit_filter_right" @click="toOpenWindow">
          <img src="@/assets/images/co-creation.png" class="co-creation-img" />
        </div>
      </div>

      <van-pull-refresh
        v-model="jobRefresh"
        success-text="刷新成功"
        @refresh="jobOnRefresh"
      >
        <van-list
          ref="list"
          class=""
          v-model="jobLoading"
          :finished="jobFinished"
          :finished-text="''"
          @load="jobOnLoad"
        >
          <div class="recruit_list" v-if="jobList.length > 0">
            <div
              class="recruit_div"
              v-for="(info, index) in jobList"
              :key="index"
              @click="jobDetail(info)"
            >
              <div class="recruit_company_title">
                <div>
                  <img
                    src="@/assets/images/fire.gif"
                    class="recruit_fire"
                    alt
                    v-if="info.ContactInfo != ''"
                  />
                </div>
                [ {{ info.Company }} ] {{ info.Title }}
              </div>
              <div class="recruit_salary" v-if="info.Salary != ''">
                薪资：{{ info.Salary }}
              </div>
              <div class="recruit_salary" v-else>
                薪资：{{ info.BasicSalary }} - {{ info.MaxSalary }}
              </div>
              <div class="recruit_officeModeName_workTypeName">
                <div class="recruit_officeModeName">
                  {{ info.OfficeModeName }}
                </div>
                <div class="recruit_workTypeName">{{ info.WorkTypeName }}</div>
              </div>
              <div class="recruit_time">{{ info.TimeDesc }}</div>
            </div>
          </div>

          <div class="recruit_noData" v-else>
            <div class="noData_image">
              <img src="@/assets/images/no_data.png" class="noData_img" alt />
            </div>
            <div class="noData_btn" @click="resetRefresh()">重置刷新</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="recruit_right">
      <div class="learnBox flex-col" style="margin: 20px 0 0 0;">
        <div class="hot-head flex-row">
          <img src="@/assets/images/digitalIcon3.png" alt="" class="hot-img" />
          <div class="hot-title">{{ "学习推荐" }}</div>
        </div>
        <div class="hot-body flex-col">
          <div class="banner-contact">
            <el-carousel
              :interval="2500"
              height="180px"
              indicator-position="none"
              arrow="always"
            >
              <el-carousel-item
                v-for="item in learnList.SubList"
                :key="item.id"
              >
                <div class="carouseData">
                  <img
                    alt=""
                    :src="item.Url || placeholder"
                    class="carouseImg"
                    style=""
                    @click="toLearnDetail(item.article)"
                  />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <time-line
        v-if="infoList.length > 0"
        :title="'WEB3 加密资讯'"
        :item="infoList"
        :type="1"
        ref="timeLineInfo"
        style="margin: 24px 0 0 0"
      >
      </time-line>
      <div
        v-else
        class="timeLineNoData"
        style="margin: 107px 0 0 0"
        v-loading="infoLoading"
        element-loading-text="加载中。。。"
      ></div>
    </div>

    <!--侧边联系方式-->
    <div class="side_contactInfo">
      <ul class="side_ul">
        <li
          v-for="(item, index) in ciImages"
          :key="index"
          class="side_li"
          @click="getContact(item)"
        >
          <img :src="item.src" class="side_img" alt />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import TimeLine from "@/components/timeLine/timeLine.vue";
import {
  getJobList,
  getTempList,
  getArticleRecommend,
  getLearnList,
} from "@/config/api.js";
import Vue from "vue";
import { PullRefresh, List } from "vant";
import { Popover, Button, Carousel, CarouselItem, Loading } from "element-ui";
Vue.use(PullRefresh, List)
  .use(Loading)
  .use(Popover)
  .use(Button)
  .use(Carousel)
  .use(CarouselItem);
export default {
  components: {
    "time-line": TimeLine,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      infoList: [], // WEB3 头条资讯
      learnList: [], // 学习推荐
      infoLoading: false,
      jobList: [], // 招聘信息
      tempList: [], // 外包任务
      tempListToShow: [],
      filterColor: {
        0: "temp_status5",
        1: "temp_status1",
        2: "temp_status5",
        3: "temp_status5",
        4: "temp_status5",
        5: "temp_status5",
      },
      filterJobList: ["全部", "开发类", "运营类", "设计类", "销售类", "产品类"], // 筛选职位列表
      filterTimeList: [
        {
          name: "全部",
          value: 0,
        },
        {
          name: "今日",
          value: 1,
        },
        {
          name: "近三天",
          value: 3,
        },
        {
          name: "近七天",
          value: 7,
        },
        {
          name: "近一个月",
          value: 31,
        },
        {
          name: "近三个月",
          value: 93,
        },
      ], // 筛选职位列表

      jobLoading: false,
      jobFinished: false,
      jobRefresh: false,

      page: 1,
      totalPage: 0,

      Key: "",

      isFilterJob: false, // 是否显示筛选内容
      type: 0, // 分类选择
      Days: 0, // 时间范围

      ciImages: [
        {
          src: require("@/assets/images/ci_x.png"),
          url: "https://x.com/hita_dao",
        },
        {
          src: require("@/assets/images/ci_discord.png"),
          url: "https://discord.gg/RTQzWkTF",
        },
        {
          src: require("@/assets/images/ci_telegram.png"),
          url: "https://t.me/+Wvs9ML0Ll9YxYjJl",
        },
        {
          src: require("@/assets/images/ci_github.png"),
          url: "https://github.com/hitadao",
        },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.refresh === "1") {
        vm.jobOnRefresh();
      }
    });
  },
  beforeMount() {
    var that = this;
    that.infoLoading = true;
    that.requestGetJobListTemp();
    that.requestLearningRecommend();
    that.requestGetArticleRecommend();
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  created() {
    this.updateItems(); // 初始化显示的数据
    window.addEventListener("resize", this.updateItems); // 监听窗口大小变化
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("resize", this.updateItems); // 移除监听器
  },
  methods: {
    // 下拉刷新
    jobOnRefresh() {
      var that = this;
      that.jobRefresh = false;
      that.jobLoading = true;
      that.jobFinished = false;
      that.page = 1;
      that.jobList = [];
      that.requestGetJobListTemp();
      that.requestGetJobList(that.type, that.Days);
    },
    // 上划加载
    jobOnLoad() {
      var that = this;
      that.jobLoading = true;
      that.requestGetJobList(that.type, that.Days);
    },
    // 查询jobList
    requestGetJobList(type, Days) {
      var that = this;
      var params = {
        limit: 10,
        page: that.page,
        Key: that.Key,
        Type: type,
        Days: Days,
      };
      getJobList(params).then((res) => {
        if (res.data) {
          that.jobRefresh = false;
          that.jobLoading = false;

          that.jobList = that.jobList.concat(res.data.data);

          that.totalPage = res.data.totalPage;
          if (that.page >= that.totalPage) {
            that.jobFinished = true;
          } else {
            that.page++;
          }
        }
      });
    },
    // 查询jobList(外包)
    requestGetJobListTemp() {
      var that = this;
      var params = {
        limit: 4,
        page: 1,
      };
      getTempList(params).then((res) => {
        if (res.data) {
          that.tempList = res.data.data;
          that.updateItems();
        }
      });
    },
    // 搜索查询
    searchJobs() {
      var that = this;
      that.isFilterJob = false;
      that.jobRefresh = false;
      that.jobLoading = true;
      that.jobFinished = false;
      that.page = 1;
      that.jobList = [];
      that.requestGetJobList(that.type, that.Days);
    },
    // 招聘详情
    jobDetail(info) {
      const url = "https://hitajobs.com/jobs/" + info.Slug + ".html";
      window.open(url, "_blank");
    },
    // 临时任务详情
    tempDetail(item) {
      var that = this;
      that.$router.push({
        path: "/tempDetail",
        query: {
          article: item.Slug,
        },
      });
    },
    // 临时任务更多
    tempMore() {
      var that = this;
      that.$router.push({
        path: "/tempMore",
        query: {},
      });
    },
    // 获取联系
    getContact(item) {
      window.open(item.url, "_blank");
    },
    // 重置刷新
    resetRefresh() {
      var that = this;
      that.type = 0;
      that.Days = 0;
      that.Key = "";
      that.isFilterJob = false;
      that.jobRefresh = false;
      that.jobLoading = true;
      that.jobFinished = false;
      that.page = 1;
      that.jobList = [];
      that.requestGetJobListTemp();
      that.requestGetJobList(that.type, that.Days);
    },
    updateItems() {
      // 根据屏幕大小决定要显示的数据数量
      this.tempListToShow = this.tempList.slice(0, this.getItemsCount());
    },
    getItemsCount() {
      // 通过屏幕宽度判断需要显示的数据数量
      const width = window.innerWidth;
      if (width > 1440) {
        return 4;
      } else if (width <= 1440 && width > 958) {
        return 3;
      } else if (width <= 958 && width > 640) {
        return 2;
      } else if (width <= 640) {
        return 1;
      }
    },

    // 最新文章数据
    requestGetArticleRecommend() {
      var that = this;
      var param = { page: 1, type: 0, limit: 15 };
      getArticleRecommend(param).then((res) => {
        if (res.data) {
          that.infoList = res.data;
          that.infoLoading = false;
        }
      });
    },
    // 学习推荐
    async requestLearningRecommend() {
      getLearnList().then((res) => {
        if (res.data) {
          this.learnList = res.data[0];
        }
      });
    },
    toLearnDetail() {
      window.open("https://binschool.org");
    },
    toOpenWindow() {
      const url = "https://github.com/hitadao";
      window.open(url, "_blank");
    },
  },
  filters: {
    filterStatus(val) {
      if (val != "" && val != null && val != undefined) {
        if (val == 1) {
          return "进行中";
        } else if (val == 5) {
          return "已结束";
        } else {
          return "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recruit_content {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: #f6f6f6;
  padding: 60px 10% 38px 10%;

  display: flex;

  .recruit_left {
    width: calc(100% - 400px);
  }
  .recruit_right {
    display: block;
    width: 400px;
    margin: 0 0 0 24px;

    .timeLineNoData {
      width: 376px;
      height: 512px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #ececec;
    }

    .learnBox {
      width: 376px;
      // background: pink;
      height: auto;
      margin: 0 0 0 0;

      .hot-head {
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 17px;
        .hot-img {
          padding: 0px 0px 0 0px;
          width: 25px;
          height: 100%;
          object-fit: contain;
        }
        .hot-title {
          margin-left: 10px;
          width: calc(100% - 25px);
          height: 100%;
          font-size: 20px;
          font-weight: bold;
          color: #222;
        }
        .hot-change {
          width: 70px;
          height: 100%;
          font-size: 14px;
          color: #626675;
          text-align: right;
          cursor: pointer;
        }
        .hot-change:hover {
          color: #f31111;
        }
      }

      .hot-body {
        margin-top: 5px;
        height: auto;
        //background: yellow;
        overflow: hidden;
        border: solid 0.08em #eeeeee;
        border-radius: 10px;
        padding: 5px;
      }
      .hot-box {
        padding: 7px 10px;
        height: auto;
        line-height: 20px;

        .img {
          font-size: 18px;
          font-weight: 600;
          height: 100%;
          width: 35%;
          // background: #00d764;
          object-fit: cover;
        }
        .hot-right {
          height: 100%;
          text-align: left;
          width: 65%;
          // background: #999999;
          .title {
            font-size: 13px;
            line-height: 1.5em;
            padding: 5px 0 0 8px;
            width: 95%;
            text-align: left;
            word-break: break-all;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            cursor: pointer;
            color: #a0a0a9;
          }
          .time {
            margin: 0px 0px 0px 8px;
            line-height: 25px;
            height: 25px;
            color: #a0a0a9;
          }
        }
      }
      .hot-box:hover {
        .title {
          color: #f31111;
        }
      }

      .banner-contact {
        // background: #999999;
        width: 100%;
        height: 180px;
        border-radius: 10px;
        .el-carousel__item h3 {
          opacity: 1;
          margin: 0;
          border-radius: 10px;
        }
        .el-carousel__item:nth-child(2n) {
          height: 100%;
          // background: #ffffff;
          border-radius: 10px;
        }

        .el-carousel__item:nth-child(2n + 1) {
          height: 100%;
          // background: #ffffff;
          border-radius: 10px;
        }

        .carouseData {
          display: flex;
          line-height: 100%;
          opacity: 1;
          align-items: center;
          // background: blue;
          height: 100%;
          border-radius: 10px;
          .carouseImg {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            object-fit: cover;
            // background: red;
          }
          .carouseTitle {
            left: 0;
            background: rgba(255, 255, 255, 0.1);
            border: 2px solid;
            border-image: radial-gradient(
                circle,
                rgba(255, 255, 255, 1),
                rgba(255, 255, 255, 0)
              )
              2 2;
            backdrop-filter: blur(19px);
          }
        }
      }
    }
  }
  @media screen and (max-width: 1280px) {
    .recruit_left {
      width: 100%;
    }

    .recruit_right {
      display: none;
    }
  }

  .recruit_search {
    margin: 20px 0 10px 0;
    width: 100%;
    height: 120px;
    border-radius: 80px 80px 80px 80px;
    background-image: url("https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/jobs/jobbg.png");
    background-size: cover;
    background-position: center;

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15% 0 15%;

    .search_div {
      width: calc(100%);
      height: 44px;
      background: #ffffff;
      border-radius: 30px 30px 30px 30px;
      border: 1px solid #d3e2ff;

      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 0 6% 0 6%;

      .search_input {
        width: calc(100% - 24px);
        height: calc(100% - 2px);
      }

      input::-webkit-input-placeholder {
        font-weight: normal;
        font-size: 12px;
        color: #adc9ff;
        line-height: 14px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .search_btn {
        width: 24px;
        height: 24px;
        margin: 0 0 0 24px;
        &__img {
          width: 24px;
          height: 24px;
          object-fit: contain;
          cursor: pointer;
        }
      }
    }
  }

  .recruit_temp {
    margin: 20px 0 0 0;

    .temp_head {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .temp_label {
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .temp_more {
        font-weight: normal;
        font-size: 14px;
        color: #444444;
        line-height: 16px;
        text-align: right;
        font-style: normal;
        text-transform: none;

        cursor: pointer;
      }

      .temp_more:hover {
        font-weight: bold;
      }
    }

    .temp_body {
      margin: 10px 0 0 0;
      display: flex;

      .temp_li {
        width: calc((100% - 60px) / 4);
        height: auto;
        min-height: 158px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e2e9f6;
        margin: 0 20px 0 0;
        cursor: pointer;

        .temp_title_salary {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 18px 0 0 0;
          padding: 0 12px 0 12px;

          .temp_title {
            font-weight: bold;
            font-size: 14px;
            color: #2d2d2d;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .temp_salary {
            font-weight: normal;
            font-size: 14px;
            color: #ed754c;
            line-height: 16px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }

        .temp_titleDesc {
          margin: 17px 0 0 0;
          padding: 0 12px 0 12px;

          width: 100%;
          height: 4.5em;

          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 1.5em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          white-space: normal;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .temp_status_timeDesc {
          display: flex;
          justify-content: space-between;
          align-items: center;

          width: 100%;
          height: 41px;
          background: #e2e9f6;
          border-radius: 0px 0px 8px 8px;
          padding: 0 12px 0 12px;
          margin: 10px 0 0 0;

          .temp_timeDesc {
            font-weight: normal;
            font-size: 12px;
            color: #5f7192;
            line-height: 14px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }

          .temp_status1 {
            width: 60px;
            height: 22px;
            background: #43c56f;
            border-radius: 20px 20px 20px 20px;

            font-weight: normal;
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .temp_status5 {
            width: 60px;
            height: 22px;
            background: #2c8de8;
            border-radius: 20px 20px 20px 20px;

            font-weight: normal;
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }

      .temp_li:hover {
        box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
        .temp_title {
          color: rgba(104, 155, 255, 1);
        }
      }

      .temp_li:nth-child(4n) {
        margin: 0 0 0 0;
      }

      @media screen and (max-width: 1440px) {
        .temp_li {
          width: calc((100% - 40px) / 3);
        }

        .temp_li:nth-child(4n) {
          margin: 0 0 0 0;
        }

        .temp_li:nth-child(3n) {
          margin: 0 0 0 0;
        }
      }

      @media screen and (max-width: 958px) {
        .temp_li {
          width: calc((100% - 20px) / 2);
        }

        .temp_li:nth-child(4n) {
          margin: 0 0 0 0;
        }

        .temp_li:nth-child(3n) {
          margin: 0 0 0 0;
        }
        .temp_li:nth-child(2n) {
          margin: 0 0 0 0;
        }
      }

      @media screen and (max-width: 640px) {
        .temp_li {
          width: calc(100%);
        }

        .temp_li:nth-child(4n) {
          margin: 0 0 0 0;
        }

        .temp_li:nth-child(3n) {
          margin: 0 0 0 0;
        }
        .temp_li:nth-child(2n) {
          margin: 0 0 0 0;
        }
        .temp_li:nth-child(1n) {
          margin: 0 0 0 0;
        }
      }
    }

    .temp_body_m {
      display: none;
      margin: 10px 0 0 0;

      .temp_li {
        width: calc(100%);
        height: auto;
        min-height: 158px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e2e9f6;
        cursor: pointer;

        .temp_title_salary {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 18px 0 0 0;
          padding: 0 12px 0 12px;

          .temp_title {
            font-weight: bold;
            font-size: 14px;
            color: #2d2d2d;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .temp_salary {
            font-weight: normal;
            font-size: 14px;
            color: #ed754c;
            line-height: 16px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }

        .temp_titleDesc {
          margin: 17px 0 0 0;
          padding: 0 12px 0 12px;

          width: 100%;
          height: 4.5em;

          font-weight: normal;
          font-size: 12px;
          color: #000000;
          line-height: 1.5em;
          text-align: left;
          font-style: normal;
          text-transform: none;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          white-space: normal;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .temp_status_timeDesc {
          display: flex;
          justify-content: space-between;
          align-items: center;

          width: 100%;
          height: 41px;
          background: #e2e9f6;
          border-radius: 0px 0px 8px 8px;
          padding: 0 12px 0 12px;
          margin: 10px 0 0 0;

          .temp_timeDesc {
            font-weight: normal;
            font-size: 12px;
            color: #5f7192;
            line-height: 14px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }

          .temp_status1 {
            width: 60px;
            height: 22px;
            background: #43c56f;
            border-radius: 20px 20px 20px 20px;

            font-weight: normal;
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .temp_status5 {
            width: 60px;
            height: 22px;
            background: #2c8de8;
            border-radius: 20px 20px 20px 20px;

            font-weight: normal;
            font-size: 12px;
            color: #ffffff;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }

      .temp_li:hover {
        box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
        .temp_title {
          color: rgba(104, 155, 255, 1);
        }
      }
    }
  }

  .recruit_filter {
    margin: 40px 0 20px 0;

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .recruit_filter_left {
      width: calc(100% - 451px);
    }

    .recruit_filter_right {
      width: 451px;
      height: 153px;
      .co-creation-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        cursor: pointer;
      }
    }

    @media screen and (min-width: 1280px) and (max-width: 1440px) {
      .recruit_filter_left {
        width: calc(100%);
      }
      .recruit_filter_right {
        display: none;
      }
    }

    .rf_div {
      display: flex;
      width: 100%;

      .rf_label {
        width: 70px;
        font-weight: normal;
        font-size: 16px;
        color: #7a7a7a;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: 12px 18px 0 0;
      }

      .rf_ul {
        width: calc(100% - 88px);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .rf_li {
          width: 80px;
          height: 22px;
          border-radius: 20px 20px 20px 20px;
          border: 1px solid #999999;

          font-weight: normal;
          font-size: 13px;
          color: #7a7a7a;
          line-height: 20px;
          text-align: center;
          font-style: normal;
          text-transform: none;

          margin: 12px 12px 0 0;
          cursor: pointer;
        }

        .rf_li:hover {
          background: #729bf8;
          color: #ffffff;
          border: none;
          line-height: 22px;
        }

        .active {
          background: #729bf8;
          color: #ffffff;
          border: none;
          line-height: 22px;
        }
      }
    }
  }

  .recruit_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;

    .recruit_div {
      width: calc((100% - 30px) / 3);
      height: 160px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #ececec;
      margin: 0 15px 20px 0;
      cursor: pointer;

      .recruit_company_title {
        font-weight: bold;
        font-size: 18px;
        color: #262626;
        line-height: 25px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 12px 0 0 0;
        padding: 0 16px 0 16px;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;

        display: flex;
        align-items: center;

        .recruit_fire {
          width: 15px;
          height: 15px;
          object-fit: contain;
          margin: 0 5px 0 0;
        }
      }

      .recruit_salary {
        font-weight: normal;
        font-size: 18px;
        color: #ff7d1f;
        line-height: 25px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        margin: 9px 0 0 0;
        padding: 0 16px 0 16px;
      }

      .recruit_officeModeName_workTypeName {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 14px 0 0 0;
        padding: 0 16px 0 16px;

        .recruit_officeModeName {
          width: auto;
          height: 24px;
          background: #edf3ff;
          border-radius: 6px 6px 6px 6px;
          padding: 0 8px 0 8px;

          font-weight: normal;
          font-size: 14px;
          color: #1867ff;
          line-height: 24px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .recruit_workTypeName {
          width: auto;
          height: 24px;
          background: #edf3ff;
          border-radius: 6px 6px 6px 6px;

          font-weight: normal;
          font-size: 14px;
          color: #1867ff;
          line-height: 24px;
          text-align: center;
          font-style: normal;
          text-transform: none;

          padding: 0 8px 0 8px;
          margin: 0 0 0 16px;
        }
      }

      .recruit_time {
        height: 33px;
        background: #fafafa;
        font-weight: normal;
        font-size: 12px;
        color: #a0a0a0;
        line-height: 33px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 16px 0 0 0;
        padding: 0 16px 0 16px;
        border-radius: 0 0 8px 8px;
      }
    }

    .recruit_div:hover {
      box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
      .recruit_company_title {
        color: rgba(104, 155, 255, 1);
      }
    }

    .recruit_div:nth-child(3n) {
      margin: 0 0 20px 0;
    }

    @media screen and (max-width: 1440px) {
      .recruit_div {
        width: calc((100% - 15px) / 2);
      }

      .recruit_div:nth-child(3n) {
        margin: 0 15px 20px 0;
      }

      .recruit_div:nth-child(2n) {
        margin: 0 0 20px 0;
      }
    }

    @media screen and (max-width: 958px) {
      .recruit_div {
        width: calc(100%);
      }

      .recruit_div:nth-child(3n) {
        margin: 0 15px 20px 0;
      }

      .recruit_div:nth-child(2n) {
        margin: 0 0 20px 0;
      }

      .recruit_div:nth-child(n) {
        margin: 0 0 20px 0;
      }
    }
  }

  .recruit_noData {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;

    .noData_image {
      width: 293px;
      height: 213px;
      margin: 11% 0 0 0;
      .noData_img {
        width: 293px;
        height: 213px;
        object-fit: contain;
      }
    }

    .noData_btn {
      width: 130px;
      height: 36px;
      background: #729bf8;
      border-radius: 20px 20px 20px 20px;

      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 5.5% 0 0 0;
      cursor: pointer;
    }
  }

  .side_contactInfo {
    position: fixed;
    bottom: 7.4%;
    right: 6.3%;
    z-index: 1000;

    .side_ul {
      padding: 8px 0;
      width: 60px;
      background: #ffffff;
      border-radius: 60px 60px 60px 60px;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.06);

      .side_li {
        position: relative;
        height: 56px;
        width: 60px;
        padding: 10px 0;

        .side_img {
          width: 36px;
          height: 36px;
          object-fit: contain;
          cursor: pointer;
        }
      }
    }
  }
}

@media screen and (max-width: 958px) {
  .recruit_content {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background: #f6f6f6;
    padding: 60px 4.6875% 0 4.6875%;

    .recruit_left {
      width: 100%;
    }

    .recruit_right {
      display: none;
    }

    .recruit_search {
      margin: 20px 0 10px 0;
      width: 100%;
      height: 60px;
      border-radius: 80px 80px 80px 80px;
      background-image: url("https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/jobs/jobbg.png");
      background-size: cover;
      background-position: center;

      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 7.5% 0 7.5%;

      .search_div {
        width: calc(100%);
        height: 32px;
        background: #ffffff;
        border-radius: 30px 30px 30px 30px;
        border: 1px solid #d3e2ff;

        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 0 3% 0 3%;

        .search_input {
          width: calc(100% - 24px);
          height: calc(100% - 2px);
        }

        input::-webkit-input-placeholder {
          font-weight: normal;
          font-size: 12px;
          color: #adc9ff;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .search_btn {
          width: 24px;
          height: 24px;
          margin: 0 0 0 0;
          &__img {
            width: 24px;
            height: 24px;
            object-fit: contain;
            cursor: pointer;
          }
        }
      }
    }

    .recruit_temp {
      margin: 20px 0 0 0;

      .temp_head {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .temp_label {
          font-weight: bold;
          font-size: 16px;
          color: #000000;
          line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .temp_more {
          font-weight: normal;
          font-size: 14px;
          color: #444444;
          line-height: 16px;
          text-align: right;
          font-style: normal;
          text-transform: none;

          cursor: pointer;
        }

        .temp_more:hover {
          font-weight: bold;
        }
      }

      .temp_body {
        margin: 10px 0 0 0;
        display: flex;

        .temp_li {
          width: calc((100% - 60px) / 4);
          height: auto;
          min-height: 158px;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #e2e9f6;
          margin: 0 20px 0 0;
          cursor: pointer;

          .temp_title_salary {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 18px 0 0 0;
            padding: 0 12px 0 12px;

            .temp_title {
              font-weight: bold;
              font-size: 14px;
              color: #2d2d2d;
              line-height: 16px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }

            .temp_salary {
              font-weight: normal;
              font-size: 14px;
              color: #ed754c;
              line-height: 16px;
              text-align: right;
              font-style: normal;
              text-transform: none;
            }
          }

          .temp_titleDesc {
            margin: 17px 0 0 0;
            padding: 0 12px 0 12px;

            width: 100%;
            height: 4.5em;

            font-weight: normal;
            font-size: 12px;
            color: #000000;
            line-height: 1.5em;
            text-align: left;
            font-style: normal;
            text-transform: none;

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            white-space: normal;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .temp_status_timeDesc {
            display: flex;
            justify-content: space-between;
            align-items: center;

            width: 100%;
            height: 41px;
            background: #e2e9f6;
            border-radius: 0px 0px 8px 8px;
            padding: 0 12px 0 12px;
            margin: 10px 0 0 0;

            .temp_timeDesc {
              font-weight: normal;
              font-size: 12px;
              color: #5f7192;
              line-height: 14px;
              text-align: right;
              font-style: normal;
              text-transform: none;
            }

            .temp_status1 {
              width: 60px;
              height: 22px;
              background: #43c56f;
              border-radius: 20px 20px 20px 20px;

              font-weight: normal;
              font-size: 12px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }

            .temp_status5 {
              width: 60px;
              height: 22px;
              background: #2c8de8;
              border-radius: 20px 20px 20px 20px;

              font-weight: normal;
              font-size: 12px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
        }

        .temp_li:hover {
          box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
          .temp_title {
            color: rgba(104, 155, 255, 1);
          }
        }

        .temp_li:nth-child(4n) {
          margin: 0 0 0 0;
        }

        @media screen and (max-width: 1440px) {
          .temp_li {
            width: calc((100% - 40px) / 3);
          }

          .temp_li:nth-child(4n) {
            margin: 0 0 0 0;
          }

          .temp_li:nth-child(3n) {
            margin: 0 0 0 0;
          }
        }

        @media screen and (max-width: 958px) {
          .temp_li {
            width: calc((100% - 20px) / 2);
          }

          .temp_li:nth-child(4n) {
            margin: 0 0 0 0;
          }

          .temp_li:nth-child(3n) {
            margin: 0 0 0 0;
          }
          .temp_li:nth-child(2n) {
            margin: 0 0 0 0;
          }
        }

        @media screen and (max-width: 640px) {
          .temp_li {
            width: calc(100%);
          }

          .temp_li:nth-child(4n) {
            margin: 0 0 0 0;
          }

          .temp_li:nth-child(3n) {
            margin: 0 0 0 0;
          }
          .temp_li:nth-child(2n) {
            margin: 0 0 0 0;
          }
          .temp_li:nth-child(1n) {
            margin: 0 0 0 0;
          }
        }
      }

      .temp_body_m {
        display: none;
        margin: 10px 0 0 0;

        .temp_li {
          width: calc(100%);
          height: auto;
          min-height: 158px;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #e2e9f6;
          cursor: pointer;

          .temp_title_salary {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 18px 0 0 0;
            padding: 0 12px 0 12px;

            .temp_title {
              font-weight: bold;
              font-size: 14px;
              color: #2d2d2d;
              line-height: 16px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }

            .temp_salary {
              font-weight: normal;
              font-size: 14px;
              color: #ed754c;
              line-height: 16px;
              text-align: right;
              font-style: normal;
              text-transform: none;
            }
          }

          .temp_titleDesc {
            margin: 17px 0 0 0;
            padding: 0 12px 0 12px;

            width: 100%;
            height: 4.5em;

            font-weight: normal;
            font-size: 12px;
            color: #000000;
            line-height: 1.5em;
            text-align: left;
            font-style: normal;
            text-transform: none;

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            white-space: normal;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .temp_status_timeDesc {
            display: flex;
            justify-content: space-between;
            align-items: center;

            width: 100%;
            height: 41px;
            background: #e2e9f6;
            border-radius: 0px 0px 8px 8px;
            padding: 0 12px 0 12px;
            margin: 10px 0 0 0;

            .temp_timeDesc {
              font-weight: normal;
              font-size: 12px;
              color: #5f7192;
              line-height: 14px;
              text-align: right;
              font-style: normal;
              text-transform: none;
            }

            .temp_status1 {
              width: 60px;
              height: 22px;
              background: #43c56f;
              border-radius: 20px 20px 20px 20px;

              font-weight: normal;
              font-size: 12px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }

            .temp_status5 {
              width: 60px;
              height: 22px;
              background: #2c8de8;
              border-radius: 20px 20px 20px 20px;

              font-weight: normal;
              font-size: 12px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
        }

        .temp_li:hover {
          box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
          .temp_title {
            color: rgba(104, 155, 255, 1);
          }
        }
      }
    }

    .recruit_filter {
      margin: 40px 0 20px 0;

      display: block;

      .recruit_filter_left {
        width: 100%;
      }

      .recruit_filter_right {
        display: none;
      }

      .rf_div {
        display: flex;
        width: 100%;

        .rf_label {
          width: 70px;
          font-weight: normal;
          font-size: 16px;
          color: #7a7a7a;
          line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 12px 18px 0 0;
        }

        .rf_ul {
          width: calc(100% - 88px);
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;

          .rf_li {
            width: 70px;
            height: 22px;
            border-radius: 20px 20px 20px 20px;
            border: 1px solid #999999;

            font-weight: normal;
            font-size: 13px;
            color: #7a7a7a;
            line-height: 20px;
            text-align: center;
            font-style: normal;
            text-transform: none;

            margin: 12px 12px 0 0;
            cursor: pointer;
          }

          .rf_li:hover {
            background: #729bf8;
            color: #ffffff;
            border: none;
            line-height: 22px;
          }

          .active {
            background: #729bf8;
            color: #ffffff;
            border: none;
            line-height: 22px;
          }
        }
      }
    }

    .recruit_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;

      .recruit_div {
        width: calc((100% - 30px) / 3);
        height: 160px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #ececec;
        margin: 0 15px 20px 0;
        cursor: pointer;

        .recruit_company_title {
          font-weight: bold;
          font-size: 18px;
          color: #262626;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin: 12px 0 0 0;
          padding: 0 16px 0 16px;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          display: flex;
          align-items: center;

          .recruit_fire {
            width: 15px;
            height: 15px;
            object-fit: contain;
            margin: 0 5px 0 0;
          }
        }

        .recruit_salary {
          font-weight: normal;
          font-size: 18px;
          color: #ff7d1f;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 9px 0 0 0;
          padding: 0 16px 0 16px;
        }

        .recruit_officeModeName_workTypeName {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: 14px 0 0 0;
          padding: 0 16px 0 16px;

          .recruit_officeModeName {
            width: auto;
            height: 24px;
            background: #edf3ff;
            border-radius: 6px 6px 6px 6px;
            padding: 0 8px 0 8px;

            font-weight: normal;
            font-size: 14px;
            color: #1867ff;
            line-height: 24px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .recruit_workTypeName {
            width: auto;
            height: 24px;
            background: #edf3ff;
            border-radius: 6px 6px 6px 6px;

            font-weight: normal;
            font-size: 14px;
            color: #1867ff;
            line-height: 24px;
            text-align: center;
            font-style: normal;
            text-transform: none;

            padding: 0 8px 0 8px;
            margin: 0 0 0 16px;
          }
        }

        .recruit_time {
          height: 33px;
          background: #fafafa;
          font-weight: normal;
          font-size: 12px;
          color: #a0a0a0;
          line-height: 33px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin: 16px 0 0 0;
          padding: 0 16px 0 16px;
          border-radius: 0 0 8px 8px;
        }
      }

      .recruit_div:hover {
        box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
        .recruit_company_title {
          color: rgba(104, 155, 255, 1);
        }
      }

      .recruit_div:nth-child(3n) {
        margin: 0 0 20px 0;
      }

      @media screen and (max-width: 1440px) {
        .recruit_div {
          width: calc((100% - 15px) / 2);
        }

        .recruit_div:nth-child(3n) {
          margin: 0 15px 20px 0;
        }

        .recruit_div:nth-child(2n) {
          margin: 0 0 20px 0;
        }
      }

      @media screen and (max-width: 958px) {
        .recruit_div {
          width: calc(100%);
        }

        .recruit_div:nth-child(3n) {
          margin: 0 15px 20px 0;
        }

        .recruit_div:nth-child(2n) {
          margin: 0 0 20px 0;
        }

        .recruit_div:nth-child(n) {
          margin: 0 0 20px 0;
        }
      }
    }

    .recruit_noData {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column;

      .noData_image {
        width: 293px;
        height: 213px;
        margin: 11% 0 0 0;
        .noData_img {
          width: 293px;
          height: 213px;
          object-fit: contain;
        }
      }

      .noData_btn {
        width: 130px;
        height: 36px;
        background: #729bf8;
        border-radius: 20px 20px 20px 20px;

        font-weight: normal;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin: 5.5% 0 0 0;
        cursor: pointer;
      }
    }

    .side_contactInfo {
      position: fixed;
      bottom: 3.7%;
      right: 4.65%;
      z-index: 1000;

      .side_ul {
        padding: 8px 0;
        width: 60px;
        background: #ffffff;
        border-radius: 60px 60px 60px 60px;
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.06);

        .side_li {
          position: relative;
          height: 56px;
          width: 60px;
          padding: 10px 0;

          .side_img {
            width: 36px;
            height: 36px;
            object-fit: contain;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .recruit_content {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background: #f6f6f6;
    padding: 60px 4.6875% 0 4.6875%;

    .recruit_left {
      width: 100%;
    }

    .recruit_right {
      display: none;
    }

    .recruit_search {
      margin: 20px 0 10px 0;
      width: 100%;
      height: 60px;
      border-radius: 80px 80px 80px 80px;
      background-image: url("https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/jobs/jobbg.png");
      background-size: cover;
      background-position: center;

      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 7.5% 0 7.5%;

      .search_div {
        width: calc(100%);
        height: 32px;
        background: #ffffff;
        border-radius: 30px 30px 30px 30px;
        border: 1px solid #d3e2ff;

        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 0 3% 0 3%;

        .search_input {
          width: calc(100% - 24px);
          height: calc(100% - 2px);
        }

        input::-webkit-input-placeholder {
          font-weight: normal;
          font-size: 12px;
          color: #adc9ff;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .search_btn {
          width: 24px;
          height: 24px;
          margin: 0 0 0 0;
          &__img {
            width: 24px;
            height: 24px;
            object-fit: contain;
            cursor: pointer;
          }
        }
      }
    }

    .recruit_temp {
      margin: 20px 0 0 0;

      .temp_head {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .temp_label {
          font-weight: bold;
          font-size: 16px;
          color: #000000;
          line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .temp_more {
          font-weight: normal;
          font-size: 14px;
          color: #444444;
          line-height: 16px;
          text-align: right;
          font-style: normal;
          text-transform: none;

          cursor: pointer;
        }

        .temp_more:hover {
          font-weight: bold;
        }
      }

      .temp_body {
        margin: 10px 0 0 0;
        display: none;

        .temp_li {
          width: calc((100% - 60px) / 4);
          height: auto;
          min-height: 158px;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #e2e9f6;
          margin: 0 20px 0 0;
          cursor: pointer;

          .temp_title_salary {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 18px 0 0 0;
            padding: 0 12px 0 12px;

            .temp_title {
              font-weight: bold;
              font-size: 14px;
              color: #2d2d2d;
              line-height: 16px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }

            .temp_salary {
              font-weight: normal;
              font-size: 14px;
              color: #ed754c;
              line-height: 16px;
              text-align: right;
              font-style: normal;
              text-transform: none;
            }
          }

          .temp_titleDesc {
            margin: 17px 0 0 0;
            padding: 0 12px 0 12px;

            width: 100%;
            height: 4.5em;

            font-weight: normal;
            font-size: 12px;
            color: #000000;
            line-height: 1.5em;
            text-align: left;
            font-style: normal;
            text-transform: none;

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            white-space: normal;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .temp_status_timeDesc {
            display: flex;
            justify-content: space-between;
            align-items: center;

            width: 100%;
            height: 41px;
            background: #e2e9f6;
            border-radius: 0px 0px 8px 8px;
            padding: 0 12px 0 12px;
            margin: 10px 0 0 0;

            .temp_timeDesc {
              font-weight: normal;
              font-size: 12px;
              color: #5f7192;
              line-height: 14px;
              text-align: right;
              font-style: normal;
              text-transform: none;
            }

            .temp_status1 {
              width: 60px;
              height: 22px;
              background: #43c56f;
              border-radius: 20px 20px 20px 20px;

              font-weight: normal;
              font-size: 12px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }

            .temp_status5 {
              width: 60px;
              height: 22px;
              background: #2c8de8;
              border-radius: 20px 20px 20px 20px;

              font-weight: normal;
              font-size: 12px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
        }

        .temp_li:hover {
          box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
          .temp_title {
            color: rgba(104, 155, 255, 1);
          }
        }

        .temp_li:nth-child(4n) {
          margin: 0 0 0 0;
        }

        @media screen and (max-width: 1440px) {
          .temp_li {
            width: calc((100% - 40px) / 3);
          }

          .temp_li:nth-child(4n) {
            margin: 0 0 0 0;
          }

          .temp_li:nth-child(3n) {
            margin: 0 0 0 0;
          }
        }

        @media screen and (max-width: 958px) {
          .temp_li {
            width: calc((100% - 20px) / 2);
          }

          .temp_li:nth-child(4n) {
            margin: 0 0 0 0;
          }

          .temp_li:nth-child(3n) {
            margin: 0 0 0 0;
          }
          .temp_li:nth-child(2n) {
            margin: 0 0 0 0;
          }
        }

        @media screen and (max-width: 640px) {
          .temp_li {
            width: calc(100%);
          }

          .temp_li:nth-child(4n) {
            margin: 0 0 0 0;
          }

          .temp_li:nth-child(3n) {
            margin: 0 0 0 0;
          }
          .temp_li:nth-child(2n) {
            margin: 0 0 0 0;
          }
          .temp_li:nth-child(1n) {
            margin: 0 0 0 0;
          }
        }
      }

      .temp_body_m {
        display: block;
        margin: 10px 0 0 0;

        .temp_li {
          width: calc(100%);
          height: auto;
          min-height: 158px;
          background: #ffffff;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #e2e9f6;
          cursor: pointer;

          .temp_title_salary {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 18px 0 0 0;
            padding: 0 12px 0 12px;

            .temp_title {
              font-weight: bold;
              font-size: 14px;
              color: #2d2d2d;
              line-height: 16px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }

            .temp_salary {
              font-weight: normal;
              font-size: 14px;
              color: #ed754c;
              line-height: 16px;
              text-align: right;
              font-style: normal;
              text-transform: none;
            }
          }

          .temp_titleDesc {
            margin: 17px 0 0 0;
            padding: 0 12px 0 12px;

            width: 100%;
            height: 4.5em;

            font-weight: normal;
            font-size: 12px;
            color: #000000;
            line-height: 1.5em;
            text-align: left;
            font-style: normal;
            text-transform: none;

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            white-space: normal;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .temp_status_timeDesc {
            display: flex;
            justify-content: space-between;
            align-items: center;

            width: 100%;
            height: 41px;
            background: #e2e9f6;
            border-radius: 0px 0px 8px 8px;
            padding: 0 12px 0 12px;
            margin: 10px 0 0 0;

            .temp_timeDesc {
              font-weight: normal;
              font-size: 12px;
              color: #5f7192;
              line-height: 14px;
              text-align: right;
              font-style: normal;
              text-transform: none;
            }

            .temp_status1 {
              width: 60px;
              height: 22px;
              background: #43c56f;
              border-radius: 20px 20px 20px 20px;

              font-weight: normal;
              font-size: 12px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }

            .temp_status5 {
              width: 60px;
              height: 22px;
              background: #2c8de8;
              border-radius: 20px 20px 20px 20px;

              font-weight: normal;
              font-size: 12px;
              color: #ffffff;
              line-height: 22px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
        }

        .temp_li:hover {
          box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
          .temp_title {
            color: rgba(104, 155, 255, 1);
          }
        }
      }
    }

    .recruit_filter {
      margin: 40px 0 20px 0;

      display: block;

      .recruit_filter_left {
        width: 100%;
      }

      .recruit_filter_right {
        display: none;
      }

      .rf_div {
        display: flex;
        width: 100%;

        .rf_label {
          width: 70px;
          font-weight: normal;
          font-size: 16px;
          color: #7a7a7a;
          line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 12px 18px 0 0;
        }

        .rf_ul {
          width: calc(100% - 88px);
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;

          .rf_li {
            width: 70px;
            height: 22px;
            border-radius: 20px 20px 20px 20px;
            border: 1px solid #999999;

            font-weight: normal;
            font-size: 13px;
            color: #7a7a7a;
            line-height: 20px;
            text-align: center;
            font-style: normal;
            text-transform: none;

            margin: 12px 12px 0 0;
            cursor: pointer;
          }

          .rf_li:hover {
            background: #729bf8;
            color: #ffffff;
            border: none;
            line-height: 22px;
          }

          .active {
            background: #729bf8;
            color: #ffffff;
            border: none;
            line-height: 22px;
          }
        }
      }
    }

    .recruit_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;

      .recruit_div {
        width: calc((100% - 30px) / 3);
        height: 160px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #ececec;
        margin: 0 15px 20px 0;
        cursor: pointer;

        .recruit_company_title {
          font-weight: bold;
          font-size: 18px;
          color: #262626;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin: 12px 0 0 0;
          padding: 0 16px 0 16px;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          display: flex;
          align-items: center;

          .recruit_fire {
            width: 15px;
            height: 15px;
            object-fit: contain;
            margin: 0 5px 0 0;
          }
        }

        .recruit_salary {
          font-weight: normal;
          font-size: 18px;
          color: #ff7d1f;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin: 9px 0 0 0;
          padding: 0 16px 0 16px;
        }

        .recruit_officeModeName_workTypeName {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: 14px 0 0 0;
          padding: 0 16px 0 16px;

          .recruit_officeModeName {
            width: auto;
            height: 24px;
            background: #edf3ff;
            border-radius: 6px 6px 6px 6px;
            padding: 0 8px 0 8px;

            font-weight: normal;
            font-size: 14px;
            color: #1867ff;
            line-height: 24px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .recruit_workTypeName {
            width: auto;
            height: 24px;
            background: #edf3ff;
            border-radius: 6px 6px 6px 6px;

            font-weight: normal;
            font-size: 14px;
            color: #1867ff;
            line-height: 24px;
            text-align: center;
            font-style: normal;
            text-transform: none;

            padding: 0 8px 0 8px;
            margin: 0 0 0 16px;
          }
        }

        .recruit_time {
          height: 33px;
          background: #fafafa;
          font-weight: normal;
          font-size: 12px;
          color: #a0a0a0;
          line-height: 33px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin: 16px 0 0 0;
          padding: 0 16px 0 16px;
          border-radius: 0 0 8px 8px;
        }
      }

      .recruit_div:hover {
        box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
        .recruit_company_title {
          color: rgba(104, 155, 255, 1);
        }
      }

      .recruit_div:nth-child(3n) {
        margin: 0 0 20px 0;
      }

      @media screen and (max-width: 1440px) {
        .recruit_div {
          width: calc((100% - 15px) / 2);
        }

        .recruit_div:nth-child(3n) {
          margin: 0 15px 20px 0;
        }

        .recruit_div:nth-child(2n) {
          margin: 0 0 20px 0;
        }
      }

      @media screen and (max-width: 958px) {
        .recruit_div {
          width: calc(100%);
        }

        .recruit_div:nth-child(3n) {
          margin: 0 15px 20px 0;
        }

        .recruit_div:nth-child(2n) {
          margin: 0 0 20px 0;
        }

        .recruit_div:nth-child(n) {
          margin: 0 0 20px 0;
        }
      }
    }

    .recruit_noData {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column;

      .noData_image {
        width: 293px;
        height: 213px;
        margin: 11% 0 0 0;
        .noData_img {
          width: 293px;
          height: 213px;
          object-fit: contain;
        }
      }

      .noData_btn {
        width: 130px;
        height: 36px;
        background: #729bf8;
        border-radius: 20px 20px 20px 20px;

        font-weight: normal;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin: 5.5% 0 0 0;
        cursor: pointer;
      }
    }

    .side_contactInfo {
      position: fixed;
      bottom: 3.7%;
      right: 4.65%;
      z-index: 1000;

      .side_ul {
        padding: 8px 0;
        width: 60px;
        background: #ffffff;
        border-radius: 60px 60px 60px 60px;
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.06);

        .side_li {
          position: relative;
          height: 56px;
          width: 60px;
          padding: 10px 0;

          .side_img {
            width: 36px;
            height: 36px;
            object-fit: contain;
            cursor: pointer;
          }
        }
      }
    }
  }
}

/deep/.el-popover {
  width: auto;
  height: auto;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0px 14px 18px 0px rgba(85, 125, 204, 0.2);
  border-radius: 4px 4px 4px 4px;
  margin: 9px 0 0 -200px !important;
  padding: 30px 12px 30px 12px;
}

/deep/.van-pull-refresh__head {
  text-align: center;
}
/deep/.van-list__finished-text {
  text-align: center;
  margin: 15px 0 0 0;
}
/deep/.van-list__loading {
  text-align: center;
}
/deep/.el-carousel__indicators {
  display: none;
}
</style>